import React, { useState } from 'react';
import { ReactComponent as InfoIcon } from '../assets/info_icon.svg';
import { Box, Typography } from '@mui/material';

const CustomInfoIcon = ({ content, defaultTitle, position = "bottom-center" }) => {
    const [isHovered, setIsHovered] = useState(false);

    const displayContent = content ? (
        content
    ) : (
        <div>
            <h3 style={{ margin: '0 0 10px 0' }}>{defaultTitle}</h3>
            <Typography style={{ margin: 0, fontWeight: 'normal', textTransform: 'none' }} noWrap>No additional information available.</Typography>
        </div>
    );

    return (
        <Box
            style={{ position: 'relative', display: 'inline-block', cursor: 'pointer' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <InfoIcon style={{ width: '16px', height: '16px', display: 'flex', alignItems: 'center', gap: "4px", marginBlock: 'auto' }} />
            {isHovered && (
                <Box
                    className='info-content'
                    sx={{
                        position: 'absolute',
                        top: "20px",
                        left: position === "bottom-center" ? "-7.6rem" : '-6px',
                        backgroundColor: 'white',
                        border: '1px solid #ccc',
                        padding: '10px',
                        borderRadius: '5px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                        zIndex: 10,
                        whiteSpace: 'nowrap',
                        maxWidth: 300,
                        cursor: 'default',
                        ":after": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            top: position === "bottom-center" ? 0 : '-5px',
                            right: position === "bottom-center" ? '53.5%' : '',
                            left: position === "bottom-center" ? '' : '3.5%',
                            width: "10px",
                            height: "10px",
                            backgroundColor: 'rgb(255, 255, 255)',
                            transform: position === "bottom-center" ? 'translateY(-46%) rotate(45deg) translateX(-10%)' : 'translateY(0%) rotate(45deg)',
                            // z-index: 0;
                        }
                    }
                    }
                >
                    {displayContent}
                </Box>
            )
            }
        </Box>
    );
};

export default CustomInfoIcon;
